export default {"src":"/_next/static/media/new-yorker-logo.df591425.svg","height":20,"width":178,"blurWidth":0,"blurHeight":0};